// @flow

import { SET_SCREEN_AUDIO_SHARE_STATE,
    SET_SCREEN_VIDEO_SHARE_STATE } from './actionTypes';

export function setScreenAudioShareState(sharingAudio) {
    return {
        type: SET_SCREEN_AUDIO_SHARE_STATE,
        sharingAudio
    };
}


export function setScreenVideoShareState(sharingVideo) {
    return {
        type: SET_SCREEN_VIDEO_SHARE_STATE,
        sharingVideo
    };
}
